var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.5H16.5C16.2188 13.5 16 13.7188 16 14V26C16 26.2812 16.2188 26.5 16.5 26.5H18V13.5ZM19.5 13.5V26.5H25.5C25.7812 26.5 26 26.2812 26 26V14C26 13.7188 25.7812 13.5 25.5 13.5H19.5ZM16.5 12H25.5C26.5938 12 27.5 12.9062 27.5 14V26C27.5 27.0938 26.5938 28 25.5 28H16.5C15.4062 28 14.5 27.0938 14.5 26V24.75H13.25C12.8438 24.75 12.5 24.4062 12.5 24C12.5 23.5938 12.8438 23.25 13.25 23.25H14.5V20.75H13.25C12.8438 20.75 12.5 20.4062 12.5 20C12.5 19.5938 12.8438 19.25 13.25 19.25H14.5V16.75H13.25C12.8438 16.75 12.5 16.4062 12.5 16C12.5 15.5938 12.8438 15.25 13.25 15.25H14.5V14C14.5 12.9062 15.4062 12 16.5 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.b7ac18833f26439b5290618cbe1f58f9.svg";
export { ForwardRef as ReactComponent };